module.exports = {"220202001":"兴华街道","220202002":"文庙街道","220202003":"东局子街道","220202004":"新地号街道","220202005":"延安街道","220202006":"站前街道","220202007":"民主街道","220202008":"莲花街道","220202009":"通江街道","220202010":"哈达湾街道","220202011":"新建街道","220202012":"延江街道","220202071":"吉林东市商贸示范区（特殊街道）","220202100":"孤店子镇","220202101":"桦皮厂镇","220202102":"左家镇","220202200":"两家子满族乡","220202201":"土城子满族朝鲜族乡","220202401":"幸福经济管理区","220202402":"吉林哈达湾经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220202.json
// module id = 617
// module chunks = 0